const PALETTE = [
    '#009688', // teal
    '#F44336', // red
    '#673AB7', // deep purple
    '#FF9800', // orange
    '#4CAF50', // green
    '#E91E63', // pink
    '#9C27B0', // purple
    '#FF5722', // deep orange
    '#8BC34A', // light green
    '#FFC107', // amber
    '#795548', // brown
    '#CDDC39', // lime
    '#FF4081', // pink accent
    '#76FF03', // light green accent
    '#7C4DFF', // deep purple accent
    '#FFD740', // amber accent
    '#1DE9B6', // teal accent
    '#FF6E40', // deep orange accent
    '#B2FF59', // lime accent
    '#E040FB', // purple accent
    '#FFAB40', // orange accent
    '#F06292', // pink light
    '#AED581', // light green light
];

const cache = new Map<string, string>();

export function getMarketColor(conditionId: string, index: number): string {
    const cached = cache.get(conditionId);
    if (cached) return cached;
    const color = PALETTE[index % PALETTE.length];
    cache.set(conditionId, color);
    return color;
}

export function assignMarketColors(
    conditionIds: string[],
): Map<string, string> {
    const map = new Map<string, string>();
    conditionIds.forEach((id, i) => {
        const color = PALETTE[i % PALETTE.length];
        map.set(id, color);
        cache.set(id, color);
    });
    return map;
}

export function resetColorCache() {
    cache.clear();
}